import React, { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TransformationSection } from '../components/TransformationSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
import { PurchasePopup } from '../components/PurchasePopup';
export function SalesPage() {
  useEffect(() => {
    // Initialize Meta Pixel and track PageView on component mount
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-navy-900 text-cream-50 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-257">
      <Hero data-id="element-258" />
      <ProblemSection data-id="element-259" />
      <SolutionSection data-id="element-260" />
      <MechanismSection data-id="element-261" />
      <BenefitsSection data-id="element-262" />
      <IncludesSection data-id="element-263" />
      <ForWhoSection data-id="element-264" />
      <TransformationSection data-id="element-265" />
      <CTASection data-id="element-266" />
      <Footer data-id="element-267" />
      <PurchasePopup data-id="element-268" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-269">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2408288229622449&ev=PageView&noscript=1" alt="" data-id="element-270" />
      </noscript>
    </main>;
}